"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var content_1 = require("@dynamynd/content");

var core_1 = require("@dynamynd/core");

var responsive_1 = require("@dynamynd/responsive");

var routes_1 = require("@dynamynd/routes");

var sharing_1 = require("@dynamynd/sharing");

var user_1 = require("@dynamynd/user");

var utilities_1 = require("@dynamynd/utilities");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var react_redux_1 = require("react-redux");

var redux_1 = require("redux");

var styled_components_1 = __importDefault(require("styled-components"));

var components_1 = require("../../components");

var styled_1 = require("../../components/styled");

var services_1 = require("../../services");

var store_1 = require("../../store");

exports.LOGO_MASCOT_SURVEY_TAKER_SCREEN_TEST_ID = 'logo-mascot-survey-taker-screen'; // todo implement Loading logic

var SurveyTakerScreen =
/** @class */
function (_super) {
  __extends(SurveyTakerScreen, _super);

  function SurveyTakerScreen() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      hideModal: true
    };

    _this.showModal = function () {
      _this.setState({
        hideModal: !_this.state.hideModal
      });
    };

    _this.setProgressBarValue = function () {
      var _a = _this.props.progressBarState,
          totalCount = _a.totalCount,
          completedQuestions = _a.completedQuestions;
      var progress = Math.floor(completedQuestions / totalCount * 100);
      var value = !isNaN(progress) ? progress : 0;
      return value > 100 ? 100 : value;
    };

    _this.preLogoutHandler = function () {
      _this.props.surveyTakerInactive();
    };

    return _this;
  }

  SurveyTakerScreen.prototype.componentDidMount = function () {
    var _a = this.props,
        activeQuestionId = _a.activeQuestionId,
        bootstrapped = _a.bootstrapped,
        startSurveyTakingSession = _a.startSurveyTakingSession,
        updateQuestionTakingSession = _a.updateQuestionTakingSession;
    this.handleBootstrap();
    startSurveyTakingSession();

    if (bootstrapped) {
      updateQuestionTakingSession(activeQuestionId);
    }
  };

  SurveyTakerScreen.prototype.componentDidUpdate = function (prevProps) {
    var prevUserId = prevProps.userId,
        prevAccessCodes = prevProps.accessCodes;

    if (this.shouldReBootstrap(prevUserId, prevAccessCodes)) {
      this.handleBootstrap();
    }
  };

  SurveyTakerScreen.prototype.componentWillUnmount = function () {
    this.props.surveyTakerInactive();
  };

  SurveyTakerScreen.prototype.shouldReBootstrap = function (prevUserId, prevAccessCodes) {
    var _a = this.props,
        userId = _a.userId,
        accessCodes = _a.accessCodes;
    return prevUserId !== userId || !utilities_1.isEqual(prevAccessCodes, accessCodes);
  };

  SurveyTakerScreen.prototype.handleBootstrap = function () {
    var _a = this.props,
        userId = _a.userId,
        bootstrapSurvey = _a.bootstrapSurvey,
        userMO = _a.userMO,
        navigateTo = _a.navigateTo;

    if (services_1.surveyService.isSurveyScored(userMO)) {
      navigateTo(routes_1.RoutesKeysEnum.results);
      return;
    }

    if (this.shouldBootStrapSurvey()) {
      bootstrapSurvey({
        userId: userId
      });
    }
  };

  SurveyTakerScreen.prototype.shouldBootStrapSurvey = function () {
    var _a = this.props,
        userId = _a.userId,
        accessCodes = _a.accessCodes,
        bootstrapped = _a.bootstrapped; // do not fetch the data again if it's already in the store.
    // this could happen if the user has navigated to a screen which is different than the taker
    // reconsider this logic if in the future the data for the taker could be updated dynamically

    if (bootstrapped) return false;
    return !!(userId && accessCodes.length);
  };

  SurveyTakerScreen.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        WebViewComponent = _a.screenProps.components.WebViewComponent,
        _b = _a.activeQuestionInstruction,
        label = _b.label,
        content = _b.content;
    return react_1.default.createElement(responsive_1.ResponsiveContext.Consumer, null, function (_a) {
      var activeBreakpoint = _a.activeBreakpoint;
      return react_1.default.createElement(content_1.WithAdditionalContent, {
        WebViewComponent: WebViewComponent,
        includeFooter: false
      }, function (_a) {
        var showContent = _a.showContent;
        return react_1.default.createElement(components_lib_1.BackgroundWithShapes, {
          shapes: {
            topLeft: true,
            topRight: true,
            bottomLeft: true,
            bottomRight: true
          },
          shouldExpand: true
        }, react_1.default.createElement(components_1.WithModal, {
          releaseButtonLabel: "I GOT IT",
          content: content,
          label: label,
          hideModal: _this.state.hideModal,
          modalClose: _this.showModal
        }), react_1.default.createElement(components_lib_1.Header, null, react_1.default.createElement(components_lib_1.LogoMascot, {
          color: "white",
          testID: exports.LOGO_MASCOT_SURVEY_TAKER_SCREEN_TEST_ID
        }), react_1.default.createElement(user_1.UserProfileBox, {
          showInstructions: _this.showModal,
          showPrivacy: function showPrivacy() {
            return showContent(content_1.ContentPagesEnum.privacy);
          },
          showTerms: function showTerms() {
            return showContent(content_1.ContentPagesEnum.terms);
          },
          preLogout: _this.preLogoutHandler
        })), react_1.default.createElement(ProgressBarFixer, null, react_1.default.createElement(components_1.SurveyProgressBar, {
          value: _this.setProgressBarValue(),
          symbol: "%"
        })), react_1.default.createElement(components_1.QuestionBlock, null), activeBreakpoint !== responsive_1.ActiveBreakpointEnum.small ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(styled_1.WrapperBottomRight, {
          onPress: _this.showModal
        }, react_1.default.createElement(styled_1.ImageStyled, {
          source: {
            uri: components_lib_1.appConfig.images.mascot
          },
          resizeMode: "stretch"
        })), react_1.default.createElement(styled_1.QuestionWrapperRight, {
          onPress: _this.showModal
        }, react_1.default.createElement(styled_1.IconWrapper, null, react_1.default.createElement(components_lib_1.Icon, {
          name: 'information-outline',
          size: responsive_1.isMedium(activeBreakpoint) ? components_lib_1.IconSizeEnum.small : components_lib_1.IconSizeEnum.medium
        })), react_1.default.createElement(styled_1.ImageWrapper, null, react_1.default.createElement(styled_1.ImageStyled, {
          source: {
            uri: components_lib_1.appConfig.images.instructionsBackground
          },
          resizeMode: "stretch"
        })))) : null);
      });
    });
  };

  return SurveyTakerScreen;
}(react_1.default.Component);

exports.SurveyTakerScreen = SurveyTakerScreen;
var ProgressBarFixer = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: 50px;\n"], ["\n    margin-bottom: 50px;\n"])));

var mapStateToProps = function mapStateToProps(state) {
  return {
    userId: user_1.userIdSelector(state),
    userMO: user_1.userMOSelector(state),
    accessCodes: store_1.accessCodesSelector(state),
    activeQuestionInstruction: store_1.activeQuestionInstructionSelector(state),
    showInstruction: state.survey.questionsState.showInstruction,
    progressBarState: store_1.progressBarStateSelector(state),
    bootstrapped: store_1.questionsStateBootstrappedSelector(state),
    activeQuestionId: store_1.activeQuestionIdSelector(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    bootstrapSurvey: redux_1.bindActionCreators(store_1.bootstrapSurveyActionCreator, dispatch),
    startSurveyTakingSession: redux_1.bindActionCreators(store_1.startSurveyTakingSessionActionCreator, dispatch),
    surveyTakerInactive: redux_1.bindActionCreators(store_1.surveyTakerInactiveActionCreator, dispatch),
    updateQuestionTakingSession: redux_1.bindActionCreators(store_1.updateQuestionTakingSessionActionCreator, dispatch)
  };
};

var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
var hoc = redux_1.compose(connector, core_1.withNavigateTo, sharing_1.withAddThisSharing);
exports.default = hoc(SurveyTakerScreen);
var templateObject_1;